module.exports = __webpack_public_path__ + "static/solvScore-131e274c253df972fc10fdc08595eace.png";